import axios from 'axios';

// 1. Axios instance banao
const api = axios.create({
  baseURL: 'https://api.satrixstore.in/api', // Apne API ka base URL yahan rakho
});

// 2. Request Interceptor (Har call mein token attach karega)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 3. Response Interceptor (Expiry handle karega)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Agar 401 error aaya aur pehle retry nahi kiya hai
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Refresh token endpoint ko call karo
        const { data } = await axios.post('https://api.satrixstore.in/api/refresh', {}, {
          withCredentials: true // Cookie bhejne ke liye zaroori hai
        });

        // Naya token mil gaya, usse update karo
        localStorage.setItem("token", data.accessToken);
        
        // Purani request mein naya token lagao aur wapas call karo
        originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        console.error("Refresh failed, logging out...");
        localStorage.removeItem("token");
        window.location.href = "/admin"; // Force logout
      }
    }
    return Promise.reject(error);
  }
);

export default api;